export const lineColors: any = {
  0: "#006AB3",
  1: "#F4BD00", // Index 1
  2: "#7BB728", // Index 2
  3: "#00B9F4", // Index 3
  green: "#7BB728",
  yellow: "#F4BD00",
  blue: "#006AB3",
  lightBlue: "#00B9F4",
};

export const gradients: any = {
  0: "linear-gradient(#B8D78E,#7BB728 )", // Index 0
  1: "linear-gradient(90deg, #F4BD00 0%, #FFE49F 100%)", // Index 1
  2: "linear-gradient(90deg, #11A9FF 0%, #016AB3 100%)", // Index 2
  3: "#00B9F4", // Index 3
  green: "linear-gradient(90deg, #B8D78E 0%, #7BB728 100%)",
  yellow: "linear-gradient(90deg, #F4BD00 0%, #FFE49F 100%)",
  blue: "linear-gradient(90deg, #11A9FF 0%, #016AB3 100%)",
};
